export default __webpack_public_path__ + "static/media/eastlink.ff8439e6.png";